import { render } from "./ProcessorActionRequiredSummary.vue?vue&type=template&id=643a7b35&scoped=true"
import script from "./ProcessorActionRequiredSummary.vue?vue&type=script&lang=js"
export * from "./ProcessorActionRequiredSummary.vue?vue&type=script&lang=js"

import "./ProcessorActionRequiredSummary.vue?vue&type=style&index=0&id=643a7b35&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-643a7b35"]])

export default __exports__